module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"continue":"Fortsett"},"en":{"continue":"Continue"}}')
  delete Component.options._Ctor
}
